var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoderation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5262_13934)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F26A1C"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5262_13934)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 2.5,
    r: 28,
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_5262_13934)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -6.41797,
    cy: 76.9141,
    r: 47.25,
    fill: "#FF006B"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5262_13934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6396 14.7344C37.4006 14.7346 38.8355 16.1668 38.8389 17.9277L38.8643 31.6367L38.7627 31.7393L38.708 31.7939V31.7949L38.5488 31.9531L38.541 31.9609L38.1689 32.335V32.334L38.0596 32.4424L38.0469 32.4551L31.6631 38.8945C31.6015 38.9562 31.5519 39.0127 31.5156 39.0566C31.4788 39.1012 31.4484 39.1411 31.4258 39.1719C31.4152 39.1863 31.406 39.2014 31.3965 39.2148L31.1318 39.4805L30.9902 39.9785L30.708 40.9746H20.3232C18.5588 40.9746 17.1231 39.5389 17.123 37.7744V17.9346C17.123 16.1701 18.5588 14.7344 20.3232 14.7344H35.6396ZM22.2432 37.7803H30.5635V36.501H22.2432V37.7803ZM22.2432 35.2207H33.7627V33.9404H22.2432V35.2207ZM29.7236 28.1621C29.4038 28.5314 28.8384 28.835 28.0127 28.835C27.1721 28.835 26.6224 28.5263 26.3096 28.1699C26.0681 28.3728 25.6823 28.5252 25.2568 28.6924L25.252 28.6943C24.2627 29.0831 23.0353 29.5655 22.9434 31.1006L22.9277 31.3701H33.0977L33.082 31.1006C32.9901 29.5652 31.7676 29.0831 30.7812 28.6943L30.7773 28.6924C30.3497 28.5231 29.9642 28.368 29.7236 28.1621ZM27.9814 20.5742C27.0488 20.591 26.367 20.8695 25.9531 21.4141C25.4633 22.0595 25.3739 23.0425 25.6836 24.3281C25.5698 24.4677 25.484 24.6799 25.5176 24.9619C25.5839 25.5183 25.8071 25.7497 25.9854 25.8418C26.0716 26.2813 26.3143 26.7733 26.5479 27.0059V27.124C26.5488 27.2912 26.545 27.45 26.5391 27.6152C26.6717 27.8925 27.0929 28.3281 28.0127 28.3281C28.9393 28.3281 29.3713 27.8841 29.4941 27.5762C29.4905 27.4627 29.4919 27.3533 29.4932 27.2412C29.4936 27.2028 29.4939 27.1634 29.4941 27.124V27.0059C29.7208 26.7742 29.9538 26.2812 30.04 25.8418C30.2232 25.7507 30.4405 25.5203 30.5078 24.9619C30.5414 24.6861 30.4603 24.4765 30.3496 24.3369C30.4971 23.835 30.7977 22.528 30.2783 21.6914C30.0605 21.3409 29.7305 21.1193 29.2959 21.0332C29.0563 20.7314 28.5969 20.5743 27.9814 20.5742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7612 32.498C42.3073 32.4981 42.9084 32.6619 43.3452 33.1533C44.2185 34.027 44.2185 35.4467 43.3452 36.3203L43.1802 36.4297L36.1909 43.4189C36.0817 43.5282 36.0267 43.584 35.9175 43.584L32.6411 44.457C32.5865 44.5116 32.4769 44.5116 32.3677 44.457C32.0403 44.4022 31.8767 44.0737 31.9858 43.8008L32.9146 40.5244C32.969 40.4697 33.0242 40.3621 33.0786 40.3076L39.4673 33.8633L39.5767 33.7549L39.9585 33.3711L40.1226 33.208L40.1772 33.1533L40.2856 33.0986C40.7225 32.7164 41.2152 32.498 41.7612 32.498Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5262_13934",
    x: -23.6667,
    y: -72.1667,
    width: 149.333,
    height: 149.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.3333,
    result: "effect1_foregroundBlur_5262_13934"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5262_13934",
    x: -123.668,
    y: -40.3359,
    width: 234.5,
    height: 234.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_5262_13934"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5262_13934"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5262_13934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12.498)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoderation);
export default __webpack_public_path__ + "static/media/remoderation.40ad5c64f04ecb0606ec532e66f3cb41.svg";
export { ForwardRef as ReactComponent };